import { render } from "./SpApiCompliance.vue?vue&type=template&id=52bd61b1&scoped=true"
import script from "./SpApiCompliance.vue?vue&type=script&lang=js"
export * from "./SpApiCompliance.vue?vue&type=script&lang=js"

import "./SpApiCompliance.vue?vue&type=style&index=0&id=52bd61b1&scoped=true&lang=css"

import exportComponent from "/Users/ezink/Downloads/海/vue-antd-tool-web 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bd61b1"]])

export default __exports__